module.exports = __webpack_public_path__ + "img/fortuneteller.4396927c.png";